import { Box, Typography, Grid, Stack } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface IProps {
  variant: "error" | "success";
  expected: number;
  actual: number;
  difference: number;
  title: string;
}

const SummaryBox: React.FC<IProps> = ({
  variant,
  expected,
  actual,
  difference,
  title,
}) => {
  const { t } = useTranslation("aggregators");

  return (
    <Box
      border={"1px solid"}
      borderColor={variant === "success" ? "#47CD89" : "red"}
      mt={2}
      borderRadius={"4px"}
      p={1}
      bgcolor={variant === "success" ? "#ECFDF3" : "#FEE4E2"}
    >
      <Stack direction={"row"} gap={1.5}>
        {variant === "success" ? (
          <CheckCircleIcon fontSize="large" color="success" />
        ) : (
          <CancelIcon fontSize="large" color="error" />
        )}
        <Box width={"100%"}>
          <Typography fontWeight={500}>{title}</Typography>
          <Grid container mt={1}>
            <Grid item xs={12} sm={4}>
              <Stack>
                <Typography fontSize={"14px"}>{t("expected")}</Typography>
                <Typography
                  color={variant === "success" ? "#27965eff" : "#B32318"}
                  fontWeight={600}
                  fontSize={"14px"}
                >
                  {expected.toFixed(2)} {t("sar")}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Stack>
                <Typography fontSize={"14px"}>{t("actual")}</Typography>
                <Typography
                  color={variant === "success" ? "#27965eff" : "#B32318"}
                  fontWeight={600}
                  fontSize={"14px"}
                >
                  {actual.toFixed(2)} {t("sar")}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Stack>
                <Typography fontSize={"14px"}>{t("difference")}</Typography>
                <Typography
                  color={variant === "success" ? "#27965eff" : "#B32318"}
                  fontWeight={600}
                  fontSize={"14px"}
                >
                  {difference.toFixed(1)}%
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Stack>
    </Box>
  );
};

export default SummaryBox;
